export default "__VITE_ASSET__BdPs0wPB__"